import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m4 6.5 5 5 5-5z" })
});
export default SvgTriangle;
